<article [formGroup]="control">
  <div id="close">
    <mat-icon (click)="removeControl()">close</mat-icon>
  </div>
  <div id="content-header">
    <mat-form-field id="form-article">
      <mat-label>Article</mat-label>
      <mat-select placeholder="Sélectionner un article" formControlName="article">
        <mat-option *ngFor="let article of articles" [value]="article">
          {{article.code_article}} - {{article.designation}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="article.hasError('required')">Vous devez choisir un article</mat-error>
    </mat-form-field>
  </div>
  <div id="content">
    <img *ngIf="csv.value != undefined" mat-card-image [src]="csv | async" />
    <h3 *ngIf="article.value">{{ article.value.code_article }}</h3>
    <h3 *ngIf="article.value">{{ article.value.designation }}</h3>
  </div>
  <div id="content-footer">
    <div id="hebdo-taille" class="flex items-baseline">
      <mat-form-field id="hebdo">
        <mat-label>Change hebdomadaire</mat-label>
        <mat-select [formControl]="change">
          <mat-option></mat-option>
          <mat-option *ngFor="let change of changes" [value]="change">
            {{change.qte_semaine}}/{{change.qte_prevue}} ({{change.type_facturation.cle_ref}})
          </mat-option>
        </mat-select>
        <mat-error *ngIf="change!=null && change.hasError('required')">Vous devez renseigner le change</mat-error>
      </mat-form-field>
      <button type="button" mat-icon-button (click)="dec()" [disabled]="!article.valid">
        <mat-icon>remove_circle_outline</mat-icon>
      </button>
      <mat-form-field id="taille">
        <mat-label>Taille</mat-label>
        <input matInput [value]="taille.value ? taille.value.libelle_long:''" readonly required
          [disabled]="!article.valid || changes == null">
      </mat-form-field>
      <button type="button" mat-icon-button (click)="inc()" [disabled]="!article.valid">
        <mat-icon>add_circle_outline</mat-icon>
      </button>
    </div>
    <div id="qte-retouche">
      <mat-form-field *ngIf="facturationTypeSB()" id="qte">
        <mat-label>Quantité souhaitée</mat-label>
        <mat-select [(value)]="selected_value" placeholder="Sélectionner la quantité" formControlName="qteSouhaite">
          <mat-option [value]=1>1</mat-option>
          <mat-option [value]=2>2</mat-option>
          <mat-option [value]=3>3</mat-option>
          <mat-option [value]=4>4</mat-option>
          <mat-option [value]=5>5</mat-option>
          <mat-option [value]=6>6</mat-option>
          <mat-option [value]=7>7</mat-option>
          <mat-option [value]=8>8</mat-option>
          <mat-option [value]=9>9</mat-option>
          <mat-option [value]=10>10</mat-option>
          <mat-option [value]=11>11</mat-option>
        </mat-select>
        <mat-error *ngIf="qteSouhaite!=null && qteSouhaite.hasError('required')">Vous devez renseigner la
          quantité souhaitée</mat-error>
      </mat-form-field>
      <mat-form-field id="retouche"
        *ngIf="article.valid && (article.value.code_article.charAt(0) == 3 || article.value.code_article.charAt(0) == 7)">
        <mat-label>Retouche du bas du vêtement</mat-label>
        <mat-select placeholder="Sélectionner la longeur" formControlName="retouche"
          [disabled]="!article.valid || changes == undefined">
          <mat-option></mat-option>
          <mat-option *ngFor="let retouche of retouches" [value]="retouche">
            {{retouche}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</article>